import { Chip, Tooltip } from '@mui/material';

export default function StatusFilter({ status, setStatus, name, color }) {
  const active = status === name;

  return (
    <Tooltip
      title={name}
    >
      <Chip
        label={name}
        onClick={() => (!active ? setStatus(name) : setStatus(null))}
        color={active ? color : 'default'}
        sx={{
          flex: 1,
          overflow: 'hidden',
          cursor: 'pointer',
        }}
      />
    </Tooltip>
  );
}
